import { Navigate } from "react-router-dom";

import PropTypes from "prop-types";
import { getCurrentUser, refreshUserToken } from "services/User";
import { useMaterialUIController, setCurrentUser } from "context";
import { useState } from "react";

function ProtectedRoute({ meta, roles, children }) {
  const [authorized, setAuthorized] = useState(true);
  const [loading, setLoading] = useState(true);
  const [controller, dispatch] = useMaterialUIController();
  const { currentUser } = controller;

  let userToken = null;
  try {
    userToken = JSON.parse(localStorage.getItem("machinat_credentials"));
  } catch (error) {
    userToken = null;
  }
  const isLoggedIn = userToken !== null && userToken !== undefined;
  const currentPath = window.location.pathname;

  if (!isLoggedIn && currentPath !== "/login") {
    setLoading(false);
    setAuthorized(false);
    localStorage.removeItem("machinat_credentials");
    window.location.href = "/login";
    return null;
  }
  if (userToken && userToken.expires_in < Date.now()) {
    refreshUserToken(userToken.refresh_token).then(
      (res) => {
        localStorage.setItem(
          "machinat_credentials",
          JSON.stringify({
            access_token: res.data.access_token,
            expires_in: Date.now() + res.data.expires_in * 1000,
            refresh_token: res.data.refresh_token,
          })
        );
        return children;
      },
      () => {
        setLoading(false);
        setAuthorized(false);
        localStorage.removeItem("machinat_credentials");
        window.location.href = "/login";
        return null;
      }
    );
  }
  if (!meta.auth && isLoggedIn) {
    return <Navigate to="/dashboard" replace />;
  }
  if (!meta.auth && !isLoggedIn) {
    return children;
  }
  if (!currentUser) {
    getCurrentUser().then(
      (res) => {
        if (
          roles &&
          roles.length > 0 &&
          !roles.some((item) => res.data.data.roles.includes(item))
        ) {
          setAuthorized(false);
        } else {
          setCurrentUser(dispatch, res.data.data);
          setLoading(false);
        }
      },
      () => {
        setLoading(false);
        setAuthorized(false);
        localStorage.removeItem("machinat_credentials");
        window.location.href = "/login";
        return null;
      }
    );
  }
  if (loading) {
    return null;
  }
  if (!authorized) {
    setLoading(false);
    setAuthorized(false);
    localStorage.removeItem("machinat_credentials");
    window.location.href = "/login";
    return null;
  }
  return children;
}

ProtectedRoute.defaultProps = {
  meta: {},
  children: null,
};

ProtectedRoute.propTypes = {
  meta: PropTypes.shape({
    auth: PropTypes.bool,
  }),
  roles: PropTypes.arrayOf(PropTypes.string).isRequired,
  children: PropTypes.arrayOf(PropTypes.node),
};

export default ProtectedRoute;
